
const boardList = [
  {
    id: 2001,
    name: 'Dashboard Frontend Application',
    list: [
      {
        id: 3001,
        title: 'In Progress',
        cards: [
          { id: 1, title: 'Halaman List', priority: 'High', dueDate: 'Tomorrow', members: ['S', 'TP', 'AR'] },
          { id: 2, title: 'Membuat halaman "Buat Kategori"', priority: 'Normal', dueDate: 'Tomorrow', members: ['S', 'TP', 'AR'] },
          { id: 3, title: 'Membuat menu task baru dari FAB', priority: 'Normal', dueDate: 'Tomorrow', members: ['S', 'TP', 'AR'] },
          { id: 4, title: 'Halaman Detail Task', priority: 'Low', dueDate: 'Tomorrow', members: ['DA', 'TP', 'AR'] },
        ],
      },
      {
        id: 3003,
        title: 'Pending',
        cards: [],
      },
      {
        id: 3002,
        title: 'Complete',
        cards: [
          { id: 5, title: 'Menu action List,Board di header', priority: 'High', dueDate: 'Tomorrow', members: ['DA', 'TP', 'AR'] },
        ],
      },
      {
        id: 3004,
        title: 'Backlog',
        cards: [
          { id: 6, title: 'Menu action List,Board di header', priority: 'Low', dueDate: 'Tomorrow', members: ['DA', 'TP', 'AR'] },
        ],
      }
    ],
  },
];
export default boardList;
